var axios = require('axios');
var { error_message } = require('@managers/helpers');

const METEOROLOGICAL_STATIONS_PATH = 'meteorological_stations';

export const getMeteorologicalStations = () => {
  return new Promise(function (resolve, reject) {
    axios
      .get(METEOROLOGICAL_STATIONS_PATH, {})
      .then(function (res) {
        resolve(res.data.stations || []);
      })
      .catch(function (err) {
        console.log(error_message(err));
        reject(err);
      });
  });
};
